/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { connect } from 'react-redux'

import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'
import Loader from 'app/views/components/Loader'
import Icon from 'app/views/components/Icon'

import { getContent } from 'app/state/modules/content'
import { createOrUpdateAssessment, getAssessmentDetail } from 'app/state/modules/assessments'

import SelectCustomAssessmentContent from './SelectCustomAssessmentContent'
import SortCustomAssessmentContent from './SortCustomAssessmentContent'


class AddCustomAssessment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedContent: {},
      selectedContentModal: null,
      title: '',
      description: '',
      allowHints: true,
      selectedFilter: '',
      loading: false,
      isHackedu: null,
      step: 0,
    }
    this.renderTitle = this.renderTitle.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeValue = this.onChangeValue.bind(this)
    this.onRemoveContent = this.onRemoveContent.bind(this)
    this.onToggleContent = this.onToggleContent.bind(this)
    this.onChangeTimeLimit = this.onChangeTimeLimit.bind(this)
    this.isEdit = Boolean(this.props.match.params.assessment_uuid)
  }

  componentDidMount() {
    this.props.getContent(
      this.props.match.params.organization_uuid,
      true,
    )
    const { isTemplate } = (this.props.location.state || {})
    if (this.isEdit || isTemplate) {
      this.setState({
        loading: true,
      }, () => {
        if (isTemplate) {
          this.isEdit = false
        }
        this.props.getAssessmentDetail(
          this.isEdit ? this.props.match.params.assessment_uuid : this.props.location.state.assessmentUUID,
          (data) => {
            this.setState({
              title: isTemplate ? '' : data.title,
              isHackedu: isTemplate ? false : data.is_hackedu,
              description: data.description,
              allowHints: data.hints_active,
              selectedContent: data.content.reduce((prev, curr) => {
                prev[curr.uuid] = curr
                return prev
              }, {}),
              loading: false,
              selectedContentModal: data.content[0].uuid,
            })
          },
          true,
        )
      })
    }
  }

  onToggleContent(content, language, framework, app) {
    const { selectedContent, selectedContentModal } = this.state
    if (!selectedContent[content.uuid]) {
      this.setState({
        selectedContentModal: content.uuid,
        selectedContent: {
          ...selectedContent,
          [content.uuid]: {
            ...content,
            language: language.language_name,
            languageVersion: language.language_version,
            framework: framework.name,
            frameworkVersion: framework.version,
            app: app.name,
            timeLimit: parseInt((content.recommendedTime || 0) / 60, 10),
          },
        },
      })
    } else {
      delete selectedContent[content.uuid]
      this.setState({
        selectedContent,
        selectedContentModal: selectedContentModal === content.uuid ? null : selectedContentModal,
      })
    }
  }

  onChangeTimeLimit(contentUUID, value) {
    const { selectedContent } = this.state
    selectedContent[contentUUID].timeLimit = parseInt(value.replace(/[^0-9]+/g, ''), 10) || 0
    this.setState({
      selectedContent,
    })
  }

  onRemoveContent(contentUUID) {
    const { selectedContent } = this.state
    delete selectedContent[contentUUID]
    this.setState({
      selectedContent,
    }, () => {
      if (Object.values(selectedContent).length === 0) {
        this.setState({ step: 0 })
      }
    })
  }

  onChangeValue(key, value) {
    this.setState({
      [key]: value,
    })
  }

  onSubmit() {
    const sortedAssessment = document.querySelectorAll('#sorted-assessment-content li')
    this.setState({ loading: true }, () => {
      const { selectedContent } = this.state
      const languages = Object.values(selectedContent).reduce((prev, curr) => {
        prev[curr.language] = {
          name: curr.language,
          version: curr.languageVersion,
        }
        return prev
      }, {})
      const frameworks = Object.values(selectedContent).reduce((prev, curr) => {
        prev[curr.framework] = {
          name: curr.framework,
          version: curr.frameworkVersion,
        }
        return prev
      }, {})
      const apps = Object.values(selectedContent).reduce((prev, curr) => {
        prev.push(curr.app)
        return prev
      }, [])
      const contentUUIDs = []
      sortedAssessment.forEach((li) => {
        contentUUIDs.push({
          uuid: li.dataset.uuid,
          timeLimit: (selectedContent[li.dataset.uuid] || {}).timeLimit ? selectedContent[li.dataset.uuid].timeLimit * 60 : null,
        })
      })
      this.props.createOrUpdateAssessment(
        this.isEdit ? this.props.match.params.assessment_uuid : null,
        this.props.match.params.organization_uuid,
        this.state.title,
        this.state.description,
        this.state.allowHints,
        contentUUIDs,
        {
          language: Object.values(languages),
          framework: Object.values(frameworks),
          apps: [...new Set([...apps])],
        },
        () => this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/assessments`),
      )
    })
  }

  renderTitle() {
    if (this.state.step === 1) {
      return 'Change content order and time limits'
    }
    if (this.isEdit) {
      if (this.state.isHackedu) {
        return 'Edit Default Assessment'
      }
      return 'Edit Custom Assessment'
    }
    return 'Add Custom Assessment'
  }

  renderSteps() {
    const { isTemplate } = (this.props.location.state || {})
    switch (this.state.step) {
      case 1:
        return (
          <SortCustomAssessmentContent
            selectedContent={this.state.selectedContent}
            onChangeTimeLimit={this.onChangeTimeLimit}
            onRemoveContent={this.onRemoveContent}
            isHackedu={this.state.isHackedu}
          />
        )
      default:
        return (
          <SelectCustomAssessmentContent
            isTemplate={isTemplate}
            codeReviews={this.props.codeReviews}

            onToggleContent={this.onToggleContent}
            onChangeValue={this.onChangeValue}
            onNext={() => {
              this.setState({
                error: null,
              }, () => {
                if (!this.state.isHackedu && (this.state.title || '').trim() === '') {
                  return this.setState({ error: 'You need to enter a title' })
                }
                return this.setState({
                  step: 1,
                })
              })
            }}

            selectedContent={this.state.selectedContent}
            error={this.state.error}
            title={this.state.title}
            description={this.state.description}
            allowHints={this.state.allowHints}
            selectedFilter={this.state.selectedFilter}
            isHackedu={this.state.isHackedu}


            onTemplate={() => {
              this.isEdit = false
              this.setState({
                isHackedu: false,
              }, () => {
                this.forceUpdate()
                this.props.history.push({
                  pathname: `/admin/${this.props.match.params.organization_uuid}/assessments/add`,
                  state: {
                    assessmentUUID: this.props.match.params.assessment_uuid,
                    isTemplate: true,
                  },
                })
              })
            }}
          />
        )
    }
  }

  render() {
    if (
      !this.props.hasLoadedOrganizations
      || this.props.codeReviews.length === 0
      || this.state.loading
    ) {
      return <Loader visible />
    }
    return (
      <OrganizationLayout
        {...this.props}
        active="assessments"
        data-test-id="organization-plans-co mponent"
      >
        {this.state.step === 1 && (
          <>
            <button
              onClick={() => {
                this.setState({
                  step: 0,
                })
              }}
              className="uk-button uk-button-secondary uk-button-small uk-margin-bottom uk-flex uk-flex-middle uk-flex-center"
              type="button"
            >
              <Icon
                name="arrow-left"
                className="uk-margin-small-right"
              />
            Back to Content
            </button>
            <br />
            <br />
          </>
        )}
        <div className="uk-inline uk-width-1-1">
          <h1 className="uk-inline">
            {this.renderTitle()}
          </h1>
          {this.state.step === 1 && (
            <button
              onClick={this.onSubmit}
              className="uk-button uk-button-primary uk-position-top-right"
              type="button"
            >
              {this.isEdit ? 'Save Assessment' : 'Create Assessment'}
            </button>
          )}
        </div>

        {this.renderSteps()}
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  organizations: state.hacker.organizationsList,
  hasLoadedOrganizations: state.hacker.hasLoadedOrganizations,

  organizationsHash: state.hacker.organizationsHash,

  codeReviews: state.content.content.code_reviews || [],
})

export default connect(mapStateToProps, {
  getContent,
  createOrUpdateAssessment,
  getAssessmentDetail,
})(AddCustomAssessment)
